// extracted by mini-css-extract-plugin
export default {"policiesLinks":"PoliciesLinks_policiesLinks__zd1G9","link":"PoliciesLinks_link__Wuq5+"};